import React from 'react'
import SubHeader from '../general/SubHeader'
import WebDev from '../assets/web-dev.svg';
import SwDev from '../assets/sw-dev.svg';
import AppDev from '../assets/app-dev.svg';
import GraphicDes from '../assets/graphic-des.svg';
import { useNavigate } from 'react-router-dom';
import ScrollAnimation from 'react-animate-on-scroll';

const Services = () => {

    const navigate = useNavigate();

    return (
        <>
            <SubHeader message='Services' />


            {/* Our services section */}
            <section className='my-5'>
                <div className='container text-center'>

                    <p className='banner-subheading'><i class="fa-solid fa-laptop-code"></i> What we Offer?</p>
                    <p className='sec-heading'>Best IT Services in Prayagraj</p>

                    <div className='row mt-4'>

                        <div className='col-lg-6 col-md-6 col-12 my-2'>
                            <div className='service-area' onClick={() => window.open('https://wa.me/9454722998?text=Hey!%20Dectwin%20Services.%20Want%20to%20know%20about%20Software%20Development%20Services.', '_blank')}>
                                <img src={SwDev} className='service-img my-3' alt='Service' />
                                <p className='service-text'>Software Development</p>
                                <p className='service-info'>Creating, testing, & maintaining softwares, ensuring functionality, performance, and scalability to meet user requirements has made us the best software company in Prayagraj.</p>
                            </div>
                        </div>

                        <div className='col-lg-6 col-md-6 col-12 my-2'>
                            <div className='service-area' onClick={() => window.open('https://wa.me/9454722998?text=Hey!%20Dectwin%20Services.%20Want%20to%20know%20about%20Web%20Development%20Services.', '_blank')}>
                                <img src={WebDev} className='service-img my-3' alt='Service' />
                                <p className='service-text'>Web Development</p>
                                <p className='service-info'>We provide the custom website, ecommerce website development services in Prayagraj delivering user-friendly, responsive, and visually appealing interfaces for our clients.</p>
                            </div>
                        </div>

                        <div className='col-lg-6 col-md-6 col-12 my-2'>
                            <div className='service-area' onClick={() => window.open('https://wa.me/9454722998?text=Hey!%20Dectwin%20Services.%20Want%20to%20know%20about%20Applicatino%20Development%20Services.', '_blank')}>
                                <img src={AppDev} className='service-img my-3' alt='Service' />
                                <p className='service-text'>App Development</p>
                                <p className='service-info'>We use best latest technologies to build natively compiled applications for mobile, web, and desktop providing exclusive mobile application development services near you.</p>
                            </div>
                        </div>

                        <div className='col-lg-6 col-md-6 col-12 my-2'>
                            <div className='service-area' onClick={() => window.open('https://wa.me/9454722998?text=Hey!%20Dectwin%20Services.%20Want%20to%20know%20about%20Graphice%20Designing%20Services.', '_blank')}>
                                <img src={GraphicDes} className='service-img my-3' alt='Service' />
                                <p className='service-text'>Graphic Design</p>
                                <p className='service-info'>Creating visually captivating designs for branding, marketing, and digital platforms, we have best branding & top marketing strategies to build your solid digital presence.</p>
                            </div>
                        </div>


                    </div>
                    {/* row ends */}

                </div>
            </section>
            {/* Our services section ends */}


            {/* Banner section */}
            <section className='services-bg py-5'>
                <ScrollAnimation animateIn='zoomIn' className='container text-center text-white py-4'>


                    <p className='banner-subheading'><i class="fa-solid fa-laptop-code"></i> Contact Us</p>
                    <p className='sec-heading'>Need any kind of IT Solution<br />for your Business</p>
                    <button className='banner-btn1' onClick={() => navigate('/contact')}>Get In Touch</button>

                </ScrollAnimation>
            </section>
            {/* Banner section ends */}


            {/* Work process section */}
            <section className='banner-bg py-5'>
                <div className='container text-center'>

                    <p className='banner-subheading'><i class="fa-solid fa-laptop-code"></i> Work Process</p>
                    <p className='sec-heading'>How we work it?</p>

                    <ScrollAnimation animateIn='fadeInRight' className='row mt-lg-5 mt-4'>

                        <div className='col-lg-3 col-md-6 col-12 my-3'>
                            <div className='process-area'>
                                <p className='process-num'>01</p>
                                <i class="fa-solid text-purple fs-2 fa-object-ungroup"></i>
                                <p className='fs-5 fw-bold my-3'>Select A Project</p>
                                <p>Identify and choose a project based on your queries, needs, and requirements.</p>
                            </div>
                        </div>

                        <div className='col-lg-3 col-md-6 col-12 my-3'>
                            <div className='process-area'>
                                <p className='process-num'>02</p>
                                <i class="fa-solid text-purple fs-2 fa-flask-vial"></i>
                                <p className='fs-5 fw-bold my-3'>Research & Analysis</p>
                                <p>Conduct thorough research to understand & make informed decision making.</p>
                            </div>
                        </div>

                        <div className='col-lg-3 col-md-6 col-12 my-3'>
                            <div className='process-area'>
                                <p className='process-num'>03</p>
                                <i class="fa-solid text-purple fs-2 fa-chart-line"></i>
                                <p className='fs-5 fw-bold my-3'>Plan & Execute</p>
                                <p>Develop a detailed project plan and implement through efficient execution.</p>
                            </div>
                        </div>

                        <div className='col-lg-3 col-md-6 col-12 my-3'>
                            <div className='process-area'>
                                <p className='process-num'>04</p>
                                <i class="fa-solid text-purple fs-2 fa-clock-rotate-left"></i>
                                <p className='fs-5 fw-bold my-3'>Deliver Project</p>
                                <p>Complete project meeting client expectations and deliver within time scope.</p>
                            </div>
                        </div>

                    </ScrollAnimation>
                    {/* row ends */}

                </div>
            </section>
            {/* Work process section ends */}

        </>
    )
}

export default Services
